import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from "@mui/material";
import iconUrl from "@/assets/icons/table_line.svg";

import {
  getValueForAttribute,
  pricingRows,
  getPricingComponentByName,
} from "./getRowValues";
import {
  attributeNameCellStyles,
  emptyRowsStyles,
  getAttributeRowStyles,
  getRowStyles,
  getRowStylesByName,
} from "./styles";
import {PaymentFrequencyEnum} from "@/types/enums.ts";

interface IProps {
  allPlans: IPlan[];
  planFeatures: IPlanFeatureConfig[];
  paymentFrequency: PaymentFrequencyEnum;
}

const PlansTable: React.FC<IProps> = ({ allPlans, planFeatures, paymentFrequency }) => {

  const theme = useTheme();

  return (
    <TableContainer sx={{ overflowX: "auto", overflowY: "visible !important" }}>
      <Table sx={{ borderCollapse: "separate" }}>
        <TableBody>
          {/* Pricing */}
          {pricingRows.map((name, index) => (
            <TableRow key={index}>
              <TableCell padding="none" sx={emptyRowsStyles} />
              {allPlans.map((plan) => (
                <TableCell
                  key={plan.id}
                  padding="none"
                  sx={getRowStylesByName(name, theme, plan.mostPopular)}
                >
                  {getPricingComponentByName(plan, name, theme, paymentFrequency)}
                </TableCell>
              ))}
            </TableRow>
          ))}

          {/* Divider */}
          <TableRow>
            <TableCell padding="none" sx={emptyRowsStyles} />
            {allPlans.map((plan) => (
              <TableCell
                key={plan.id}
                padding="none"
                sx={{
                  ...getRowStyles(theme, plan.mostPopular),
                  pb: { md: 3.75 },
                }}
              >
                <Box maxWidth="100%">
                  <img
                    src={iconUrl}
                    alt="Icon"
                    style={{ width: "100%", height: "auto" }}
                  />
                </Box>
              </TableCell>
            ))}
          </TableRow>

          {/* Characteristics - attributes */}
          {planFeatures.map(
            ({ featureMasterID, featureTitle }, index, array) => (
              <TableRow key={featureMasterID}>
                <TableCell padding="none" sx={attributeNameCellStyles}>
                  {featureTitle}
                </TableCell>
                {allPlans.map(({ id, mostPopular, features }) => (
                  <TableCell
                    padding="none"
                    key={id}
                    sx={getAttributeRowStyles(
                      theme,
                      mostPopular,
                      index === array.length - 1
                    )}
                  >
                    {getValueForAttribute(features, featureMasterID)}
                  </TableCell>
                ))}
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PlansTable;
